module.exports = __webpack_public_path__ + "images/emoji/bookmark.17a05b21178edf384bb2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bookmark.png
// module id = 4RYe
// module chunks = 14